export default {
  products: (state) => state.products,
};
